export const FLAG_POSTING_ACTION = 'FLAG_POSTING_ACTION';
export const POST_ACTION = 'POST_ACTION';
export const POST_ACTION_SUCCEEDED = 'POST_ACTION_SUCCEEDED';
export const POST_ACTION_FAILED = 'POST_ACTION_FAILED';
export const FLAG_GETTING_ACTIONS = 'FLAG_GETTING_ACTIONS';
export const GET_ACTIONS_SUCCEEDED = 'GET_ACTIONS_SUCCEEDED';
export const GET_ACTIONS_FAILED = 'GET_ACTIONS_FAILED';
export const GET_ACTIONS = 'GET_ACTIONS';
